export default __webpack_public_path__ + "static/thum-video-img02-bfce62c9981bc1f83ccef3c60c28d37c.jpg";